<template>
  <SectionTemplate class="mb-md-10 overflow-hidden" :container="false">
    <v-container class="position-relative item">
      <div class="text-center text-md-left">
        <TitleWidget>Fale Conosco</TitleWidget>
      </div>

      <v-row justify="center" class="mt-6">
        <v-col cols="12" sm="10" md="6" lg="5">
          <ContactForm
            :action="files + '/rest/email/contact-us'"
            responseTo="/fale-conosco/obrigado"
          ></ContactForm>
        </v-col>

        <v-col
          v-if="informations.map"
          cols="12"
          sm="10"
          md="6"
          lg="7"
          class="map"
          v-html="informations.map"
        >
        </v-col>
      </v-row>
    </v-container>
  </SectionTemplate>
</template>

<script>
import ContactForm from "../forms/ContactForm.vue";
import SectionTemplate from "../templates/SectionTemplate.vue";
import TitleWidget from "../widgets/TitleWidget.vue";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  components: {
    SectionTemplate,
    TitleWidget,
    ContactForm,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &:before {
    background-color: var(--v-primary-base);
    content: "";
    height: 100vw;
    margin-right: 25vw;
    margin-top: -50vw;
    position: absolute;
    right: 100%;
    top: 50%;
    transform: rotate(45deg);
    width: 100vw;
  }

  .map::v-deep {
    object-fit: cover;

    @media screen and (max-width: 960px) {
      aspect-ratio: 16 / 9;
    }

    @media screen and (max-width: 600px) {
      aspect-ratio: 4 / 3;
    }

    iframe {
      display: block;
      height: 100% !important;
      width: 100% !important;
    }
  }
}
</style>
